const initialState = {
  states: [],
  loading: false,
  error: null
};

const statesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_STATES':
      return {
        ...state,
        states: action.payload,
        loading: false,
        error: null
      };
    case 'SET_STATES_LOADING':
      return {
        ...state,
        loading: action.payload
      };
    case 'SET_STATES_ERROR':
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    default:
      return state;
  };
};

export default statesReducer;
